var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BannerSmall',[_c('h2',{staticClass:"pt-5 pb-5"},[_vm._v("KuickPay BPS")])]),_c('div',{staticClass:"pt-5 container ibft-evidence"},[_c('h5',{domProps:{"innerHTML":_vm._s(_vm.instructions)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }